exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".load-btn {\n  display: inline-block;\n  background-color: #c6701f;\n  color: #eae8e8;\n  border-radius: 5px;\n  border: none;\n  width: 70px;\n  height: 25px;\n  margin: 3px;\n}\n\n@media screen and (max-width: 580px) {\n  .load-btn  {\n    font-size: 12px;\n    width: 40px;\n    height: 18px;\n    padding: 0px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/BREA/Desktop/drum-machine/src/app/load-saved-beat/load-saved-beat.component.css
// module id = ../../../../../src/app/load-saved-beat/load-saved-beat.component.css
// module chunks = main